var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWork2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M37.3334 9.06947C40.7907 10.7876 43.1667 14.3554 43.1667 18.478C43.1667 22.6007 40.7907 26.1684 37.3334 27.8866M42 40.0996C45.5268 41.6955 48.7026 44.2963 51.3334 47.6447M4.66669 47.6447C9.2085 41.864 15.3748 38.3114 22.1667 38.3114C28.9586 38.3114 35.1249 41.864 39.6667 47.6447M32.6667 18.478C32.6667 24.277 27.9657 28.978 22.1667 28.978C16.3677 28.978 11.6667 24.277 11.6667 18.478C11.6667 12.679 16.3677 7.97803 22.1667 7.97803C27.9657 7.97803 32.6667 12.679 32.6667 18.478Z",
    stroke: "#25232C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2);
export default __webpack_public_path__ + "static/media/work2.d1a4852588270a5e39b9f1ecd778706f.svg";
export { ForwardRef as ReactComponent };